import React, { Suspense, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import Header from 'src/components/Header/Header'
import Loading from 'src/components/Loading/Loading'
import { useProfile, useProfileCRUD } from 'src/hooks/api'

import './Profile.sass'

const Profile = () => {
  const initialProfile = useProfile()
  const [profile, setProfile] = useState(initialProfile)
  const handleChange = e => setProfile({ ...profile, [e.target.name]: e.target.value })
  const profileCRUD = useProfileCRUD()

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      if (profile.id) {
        await profileCRUD.update('me', profile)
      }
    } catch (error) {
      console.warn(error.message)
    }
  }

  return (
    <div id="profile" className="page">
      <Header back />
      <section id="page-content">
        <div className="container">
          <h1><FormattedMessage id="profile.title" /></h1>
          <div className="wrapper">
            <form id="user-form" onSubmit={handleSubmit}>
              <button className="filled">
                <FormattedMessage id="save" />
              </button>
              <label>
                <h2><FormattedMessage id="profile.userMail" /></h2>
                <input value={profile?.email} readOnly name="email" />
              </label>
              <label>
                <h2><FormattedMessage id="profile.userName" /></h2>
                <input value={profile?.fullname} name="fullname" onChange={handleChange} />
              </label>
              <label>
                <h2><FormattedMessage id="profile.userPhone" /></h2>
                <input value={profile?.phone} type="tel" name="phone" onChange={handleChange} />
              </label>
              <Link className="button" to="/recover">
                <FormattedMessage id="profile.change-pass" />
              </Link>
            </form>
            <div className="spaced" />
          </div>
        </div>
      </section>
    </div>
  )
}

const ProfileWrapper = () =>
  <Suspense fallback={<Loading />}>
    <Profile />
  </Suspense>

export default ProfileWrapper
